import { useCallback, useMemo, useEffect, useRef, useState } from 'react';
// import { fetchToken, onMessageListener } from "./firebase";
import { useDispatch, useSelector } from 'react-redux';
import { appDetailsByTenant, getDynamicMenus, setChartAttributes } from './redux/actions/appInfo';
import { getDPDetailsEDIS, getDeviceInfo, updateCft, updateUserId, userLoginSuccess } from './redux/actions/auth';
import Navigation from './navigation';
import { getAppInfoData, getIsConfigExist, setActiveTheme, getClientFacilityTemplate, setEncryptLocalStorage, getDecryptLocalStorage, getKeys, getUserLoggedIn, getApiExchangeNameFromMktSegId, bIsProd } from './utils/global_functions';
import { APP_INFO_PARAMS, DEEP_LINK, LOCATIONS, LOCAL_STORAGE_KEYS, MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL, ORDER_PRODUCT_TYPES, THEME_TYPE } from './utils/global_variables'; //Prachi T [06-12-2023] : Breeze- Font and Colour Settings
import { getProductTypes } from './redux/actions/orders';
import config from './config.json';
import { _getExchangeTypes, _handleTrialExpired, _storeQueryParams } from './controllers';
import { CloseAccountModal } from './containers/UserProfile';
import { OptionChainModal } from './containers/Search';
import { Header, SSOLinksModal } from './containers';
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
import { fetchToken, onMessageListener } from './firebase';
import { pushNotificationTopicSubUnsub, reSubUnSubPushNotificationTopic } from './redux/actions/setting'; //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
import { getIndices, getWorldIndicesData } from './redux/actions/indices';
import { _checkIsFirstLoginOfDay } from './controllers/edis';
import { updateReconnectionCount } from './redux/actions/wfh';
import { getTotalPages } from './redux/actions/globalSearch';
import ReactGA from "react-ga4";
import { _getOrderEntryAllExchangeWiseProductTypes } from './controllers/orders';
import { updateUserPreference } from './redux/actions/header';
import { useLocation, useNavigate } from 'react-router';
import useIsDevToolsOpen from './hooks/detectDevTools';
import { handleModal } from './redux/actions/modals';



// const TRACKING_ID = "G-B8W5FSH18L";

// ReactGA.initialize(TRACKING_ID); // DO NOT REMOVE.


ReactGA.initialize([{ trackingId: 'G-B8W5FSH18L' }]);


const App = () => {
    const dispatch = useDispatch();
    const { appInfo } = useSelector(state => state.appInfo);
    const dynamicMenus = useSelector(state => state?.appInfo?.dynamicMenus);
    const location = useLocation();

    const nWhatsHotDataIntervalTime = useMemo(() => appInfo?.length > 0 && getAppInfoData(APP_INFO_PARAMS.APP_DONTMISS_REFRESH_TIMER, appInfo) >= MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL ? getAppInfoData(APP_INFO_PARAMS.APP_DONTMISS_REFRESH_TIMER, appInfo) * 60 * 1000 : MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL * 60 * 1000, [appInfo]);
    const modals = useSelector(state => state.modals.modals);
    const userPreference = useSelector(state => state.notification.userPreference);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const userId = useSelector(state => state.auth?.userId);
    const webTopicSubUnSubResp = useSelector(state => state?.setting?.webTopicSubUnSubResp); //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
    // Ajitesh : 02/01/2024: BT-109135: Breeze eDIS implementation centralised edis summary api call - Start
    const loginSessionInfo = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    // Ajitesh : 02/01/2024: BT-109135: Breeze eDIS implementation centralised edis summary api call - Start
    const reconnectionCount = useSelector(state => state?.wfh?.reconnectionCount);
    const deviceInfo = useSelector(state => state?.auth?.deviceInfo);
    const [appInfoApiCount, setAppInfoApiCount] = useState(false);



    //Ameersha N -- TO open Devtools msg modal  on devtools open --Start
    if (useIsDevToolsOpen() && bIsProd()) {
        // here modal should be opned
        // if modal is not opned then only open modal
        if (!modals['DEV_TOOLS_MODAL']) {
            dispatch(handleModal([{ 'DEV_TOOLS_MODAL': true }]));
        } else { }
    } else {
        //if model opened then onky it shoudl be closed
        if (modals['DEV_TOOLS_MODAL']) {
            dispatch(handleModal([{ 'DEV_TOOLS_MODAL': false }]));
        } else { }
    };
    //Ameersha N -- TO open Devtools msg modal  on devtools open --End


    // Shuaib : 21/02/2024: Reconnection attempts - Start
    useEffect(() => {
        if (appInfo?.length > 0 && reconnectionCount === null) {
            let count = getAppInfoData(APP_INFO_PARAMS.APP_SOCKET_RECONNECTION_RETRY_COUNT, appInfo);
            if (count) {
                dispatch(updateReconnectionCount(count));
            } else {
                dispatch(updateReconnectionCount(-1));
            }
        }
    }, [appInfo, reconnectionCount, dispatch]);
    // Shuaib : 21/02/2024: Reconnection attempts - End


    // Shuaib : 07/04/2024:Updating Pages --Start
    useEffect(() => {
        if (Object.keys(dynamicMenus)?.length) {
            dispatch(getTotalPages());
        }
    }, [dynamicMenus, dispatch]);

    // Shuaib : 07/04/2024: Updating Pages --End

    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    const currentPreferenceFontSize = useMemo(() => {
        if (userPreference?.length) {

            const sortedUsers = [...userPreference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            const currentUserPreference = { ...sortedUsers[0] };
            const fontColorSize = currentUserPreference?.sInAppNotification ? JSON.parse(currentUserPreference?.sInAppNotification) : {};
            //Prachi T [06-12-2023] : Breeze- Font and Colour Settings - Start
            if (currentUserPreference?.sTheme === THEME_TYPE.DARK) {
                document.body.classList.add(THEME_TYPE.DARK);
                setEncryptLocalStorage(LOCAL_STORAGE_KEYS.THEME, THEME_TYPE.DARK);
            } else {
                document.body.classList.remove(THEME_TYPE.DARK);
                localStorage.removeItem(LOCAL_STORAGE_KEYS.THEME);
            }
            //Prachi T [06-12-2023] : Breeze- Font and Colour Settings - End
            return fontColorSize?.font;
        }
        else {
            return '';
        }
    }, [userPreference]);
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End


    const onInitilize = useCallback(async () => {
        var objLoginSession = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
        if (objLoginSession) {
            objLoginSession = JSON.parse(objLoginSession);
            dispatch(getProductTypes());
        } else {
            objLoginSession = {};
        }
        //BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - Start
        if (objLoginSession?.guestMode) {
            const objTrialExpiredResponse = _handleTrialExpired(appInfo, objLoginSession?.userId);
            if (objTrialExpiredResponse?.status) {
                if (objTrialExpiredResponse?.data) {
                    dispatch(userLogout()).then(() => {
                        window.location.replace('/');
                    }).catch(() => {
                        window.location.replace('/');
                    });
                }
                else {
                    handleNormalFlow(objLoginSession);
                }
            }
        }
        else {
            handleNormalFlow(objLoginSession);
        }

    }, [appInfo, dispatch]);

    const hasFetchedData = useRef(false);
    const handleNormalFlow = async (objLoginSession) => {
        const bIsConfig = getIsConfigExist();
        if (bIsConfig) {
            if (localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) == null && localStorage.getItem(LOCAL_STORAGE_KEYS.HEADER) == null && !hasFetchedData.current) {
                hasFetchedData.current = true;
                await getKeys();
            }
            if (appInfo?.length === 0) {
                if (localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) !== null && localStorage.getItem(LOCAL_STORAGE_KEYS.HEADER) !== null) {
                    await dispatch(appDetailsByTenant());
                    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
                    dispatch(getDynamicMenus());
                    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End
                    dispatch(updateUserId(objLoginSession?.data?.user_id));
                    dispatch(userLoginSuccess(objLoginSession));
                    setActiveTheme();
                    const storedChartAttributes = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.CHART_URL_ATTRIBUTES));
                    if (storedChartAttributes) {
                        dispatch(setChartAttributes({ ...storedChartAttributes }));
                    }
                }
            } else {
                const cft = getClientFacilityTemplate(objLoginSession?.data?.others?.CFT, appInfo);
                dispatch(updateCft(cft));
            }
            // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - Start
            if (Object.keys(objLoginSession).length) {
                if (!Object?.keys(objLoginSession)?.includes('guestMode')) {
                    dispatch(getDPDetailsEDIS());
                } else { }

            }
            // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - End
        } else {
            if (window.location.pathname === '/') {
                window.location.replace('/environmentSetting');
            } else { }
        }
    };
    const getPos = useCallback((pos) => {
        if (appInfo?.length) {
            let verNo = getAppInfoData(APP_INFO_PARAMS.APP_BREEZE_VERSION, appInfo);
            let temp = {
                "deviceinfo": {
                    "DeviceSerialNo": window.navigator.productSub,
                    "DeviceManufacturer": window.navigator.vendor,
                    "DevicePlatform": "Breeze",
                    "DevicePlatformVer": window.navigator.userAgent,
                    "Longitude": pos?.coords?.longitude || "",
                    "Latitude": pos?.coords?.latitude || "",
                    "AppName": "Breeze",
                    "AppVersion": window.navigator.appVersion,
                    "AppVersionCode": verNo,
                    "FCMRegKey": window.location.host, //initiaise se registered key => app.
                }
            };
            dispatch(getDeviceInfo(temp?.deviceinfo));
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.DEVICE_INFO, JSON.stringify(temp?.deviceinfo));
        }
    }, [appInfo, dispatch]);

    useEffect(() => {
        if (!deviceInfo) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getPos, getPos);
            }
        }
    }, [getPos, deviceInfo]);

    //BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - End


    // Azeem K :29-05-2024 : seprated useEffect for BT-109052 - Breeze- Font and Colour Settings - Start
    useEffect(() => {
        let interval;

        if (nWhatsHotDataIntervalTime) {
            interval = setInterval(() => {

                //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - Start
                if (webTopicSubUnSubResp && Object.keys(webTopicSubUnSubResp)?.length && !webTopicSubUnSubResp?.status) {
                    const subList = webTopicSubUnSubResp?.result?.subList?.fail;
                    const unSublist = webTopicSubUnSubResp?.result?.unSublist?.fail;
                    const fcmToken = getDecryptLocalStorage(`FCM_TOKEN_${userId}`);
                    dispatch(reSubUnSubPushNotificationTopic({ fcmToken, subList, unSublist }));
                }
                //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - End
            }, nWhatsHotDataIntervalTime);
        } else { }

        return (() => {
            clearInterval(interval);
        });
    }, [nWhatsHotDataIntervalTime, userId, webTopicSubUnSubResp, dispatch]); //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
    // Azeem K :29-05-2024 : seprated useEffect for BT-109052 - Breeze- Font and Colour Settings - End


    useEffect(() => {
        _storeQueryParams();
        //Azeem K :14-05-2025: commented as of now because not working
        // if(!appInfoApiCount){
        onInitilize();
        //     setAppInfoApiCount(true)
        // }
    }, [onInitilize, objLoginSession]);

    useEffect(() => {

        if (objLoginSession?.data?.access_token) {
            dispatch(getIndices());
            dispatch(getWorldIndicesData());
        }
    }, [dispatch, objLoginSession]);

    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    useEffect(() => {
        if (userId && userPreference?.length) {
            const sortedUsers = [...userPreference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            const currentUserPreference = { ...sortedUsers[0] };
            const topicList = currentUserPreference?.sNotification ? JSON.parse(currentUserPreference?.sNotification) : [];

            Notification.requestPermission()
                .then(permission => {
                    if (permission === 'granted') {
                        //firebase notification
                        fetchToken(userId, () => {
                            dispatch(pushNotificationTopicSubUnsub(topicList));
                        });
                    }
                }).catch(err => console.log(err));
        }
    }, [userId, userPreference, dispatch]);

    onMessageListener((payload) => {
        new Notification(payload?.notification?.title);
    });
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End


    //Maaz A : 05-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    useEffect(() => {
        // for the disabling right click / contextmenu event
        const handleContextMenu = (e) => {
            // prevent the right-click menu from appearing
            e.preventDefault();
        };

        document.addEventListener("contextmenu", handleContextMenu);
        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);
    //Maaz A : 05-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - End


    useEffect(() => {
        if (getDecryptLocalStorage(DEEP_LINK) !== null) {
            const pageToNavigate = JSON.parse(getDecryptLocalStorage(DEEP_LINK));
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.SELECTED_ROUTE, pageToNavigate?.navigate);
        }
    }, []);

    // Ajitesh : 10/01/2024: BT-109135: Breeze eDIS implementation - Store and check first login of day in localStorage - Start
    useEffect(() => {
        if (loginSessionInfo) {
            _checkIsFirstLoginOfDay(loginSessionInfo);
        }
    }, [loginSessionInfo]);
    // Ajitesh : 10/01/2024: BT-109135: Breeze eDIS implementation - Store and check first login of day in localStorage - End



    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search, title: 'Custom Title' });
    }, []);


    /*  Shuaib P [14/05/2024] - consoling build details --Start*/

    useEffect(() => {
        if (config) {
            document.title = config.Title;
            const url = config.Wave.URL;
            const environment = bIsProd() ? 'PROD' : 'DEV';
            const tenant = config.TenantId;
            let wfhConnectionString;
            let messageSocket;
            let strActiveSession = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
            if (strActiveSession) {
                let objActiveSession = JSON.parse(strActiveSession);
                wfhConnectionString = objActiveSession?.data?.others?.broadCastSocket;
                messageSocket = objActiveSession?.data?.others?.messageSocket;
            }
            let infoTable = {
                'URL': url,
                'Tenant': tenant,
                'BCast': wfhConnectionString,
                'Msg': messageSocket,
                'Environment': environment,
                'Build Date': config.buildDate,
                'Build Version': config.buildVersion
            };
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.SOCKET_HEALTH_INFO, JSON.stringify(infoTable));
        }

    }, [config]);

    /*  Shuaib P [14/05/2024] - consoling build details --End*/
    const productTypes = useSelector(state => state.orders.productTypes);

    useEffect(() => {
        const exchanges = objLoginSession?.data?.exchanges;

        if (userPreference?.length) {
            const objActiveUserPreference = userPreference[userPreference?.length - 1];

            const sortedUsers = [...userPreference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            const currentUserPreference = { ...sortedUsers[0] };
            const currentPreference = currentUserPreference;
            const objDefaultProdTypes = getAppInfoData(APP_INFO_PARAMS.APP_DEFAULT_PRODUCT, appInfo);

            let arrExchangeTypes = [];
            if (currentPreference) {
                arrExchangeTypes = _getExchangeTypes(exchanges, currentPreference);
            }

            const userPreferenceExchanges = currentPreference?.sExchange?.length ? JSON.parse(currentPreference?.sExchange) : [];

            const arrNewUserPreferenceExchanges = [];
            arrExchangeTypes?.forEach((objExchange) => {
                const nIndx = userPreferenceExchanges?.findIndex(exchangType => exchangType?.exchange === objExchange?.exchange);
                if (nIndx < 0) {
                    // if exchange is not in userPreference 
                    const strrExchange = getApiExchangeNameFromMktSegId(objExchange.marketSegmentId);
                    let strProductTypeFromAppinfo = objDefaultProdTypes[strrExchange];//product type from member /appInfo
                    if (strrExchange.includes('EQ') && strProductTypeFromAppinfo === ORDER_PRODUCT_TYPES.INTRADAY) {
                        strProductTypeFromAppinfo = ORDER_PRODUCT_TYPES.MARGIN;
                    } else if (!strrExchange.includes('EQ') && strProductTypeFromAppinfo === ORDER_PRODUCT_TYPES.DELIVERY) {
                        strProductTypeFromAppinfo = ORDER_PRODUCT_TYPES.CARRYFORWARD;
                    }

                    const objResp = _getOrderEntryAllExchangeWiseProductTypes(productTypes, strrExchange, objLoginSession);
                    const arrAllExchangeWiseProductTypes = objResp?.data || [];//array of products allowed to user for particular exchange/segment
                    if (arrAllExchangeWiseProductTypes?.length > 0) {
                        let tempObj = { ...objExchange };
                        const objDefaultType = arrAllExchangeWiseProductTypes?.find((product) => product?.sDefaultProductType === strProductTypeFromAppinfo);
                        if (objDefaultType) {
                            tempObj.productType = objDefaultType?.sDefaultProductType;
                        } else {
                            // for EQ
                            if (strrExchange?.includes('EQ')) {
                                const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType === ORDER_PRODUCT_TYPES.DELIVERY);
                                if (objSelProductType) {
                                    tempObj.productType = objSelProductType?.sDefaultProductType;
                                } else {
                                    tempObj.productType = arrAllExchangeWiseProductTypes[0]?.sDefaultProductType;
                                }

                            } else {
                                // for other than EQ
                                const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType === ORDER_PRODUCT_TYPES.CARRYFORWARD);
                                if (objSelProductType) {
                                    tempObj.productType = objSelProductType?.sDefaultProductType;
                                } else {
                                    tempObj.productType = arrAllExchangeWiseProductTypes[0]?.sDefaultProductType;
                                }
                            }

                        }
                        if (tempObj.productType) {

                            arrNewUserPreferenceExchanges?.push(tempObj);
                        }
                    }
                }
            });
            if (arrNewUserPreferenceExchanges?.length > 0) {
                const payload = {
                    sExchange: JSON.stringify(userPreferenceExchanges?.concat(arrNewUserPreferenceExchanges))
                };
                dispatch(updateUserPreference(objActiveUserPreference, payload));

            }
        }
    }, [userPreference]);
    const navigate = useNavigate();
    const handleAddendumClik = useCallback(
        (path) => {
            navigate(path);
        },
        [navigate]
    );



    return (
        <div className={currentPreferenceFontSize ? `fontsize-${currentPreferenceFontSize}` : `fontsize-md`}>
            {/* Maaz A: Uncomment below jsx for prodution push and put final variable.css in CDN Path */}
            {/* {
                config?.Wave?.Cloudfront_S3_URL &&
                <link rel="stylesheet" type='text/css' href={`${config?.Wave?.Cloudfront_S3_URL}${config.TenantId}/styles/variables.css`} />
            } */}
            {getUserLoggedIn() && window.location.pathname !== LOCATIONS.HEALTHCHECK && location.pathname !== LOCATIONS.CHART && <Header />}  {/*   Ameersha N -- 24-07-2024 -- Header has been moved here to make it commong for every screen when user is logged in successfully  */}
            <Navigation />
            <CloseAccountModal />
            {modals['OPTION_CHAIN'] ? <OptionChainModal /> : null}
            {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */}
            {modals['SSO_LINK_MODAL'] ? <SSOLinksModal handleAddendumClik={handleAddendumClik} /> : null}
            {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */}
        </div>
    );
};

export default App;
